import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getPrivateProjectBankItemsOfProject = async (projectId) => {
  const apiPath = `project-bank/private/project/${projectId}/private-items`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
